export default "__VITE_ASSET__E7XgbofB__"